import autoTable from 'jspdf-autotable';
import { jsPDF } from 'jspdf';
import moment from 'moment';
import 'moment/locale/es';
import { getDataObtenerUno } from '../../api/common';
import { logoBiolab } from '../../helpers/imagen/Imagen';

moment().locale('es');

const TEAL = [34, 171, 180];

export const PdfHojaTrabajo = (hoja) => {
  if (!hoja) return;

  const doc = new jsPDF({ unit: 'cm', orientation: 'p', format: 'A4' });
  const otNum = hoja.ot?.numeroOrden || hoja.ot?._id || 'N/A';
  const consec = hoja.consecutivo || '—';

  const render = (firma) => {
    if (logoBiolab) {
      try { doc.addImage(logoBiolab, 'PNG', 1.5, 1, 3, 2); } catch (_) { /* fallback silencioso */ }
    }
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('HOJA DE TRABAJO', 10.5, 1.8, { align: 'center' });

    autoTable(doc, {
      startY: 3.3,
      theme: 'plain',
      headStyles: { fontStyle: 'bold', fontSize: 8, halign: 'center' },
      head: [
        [
          { content: 'OT', styles: { fillColor: TEAL, textColor: 255, lineColor: 10, lineWidth: 0.02 } },
          { content: otNum, styles: { lineColor: 10, lineWidth: 0.02 } },
          { content: 'Consecutivo', styles: { fillColor: TEAL, textColor: 255, lineColor: 10, lineWidth: 0.02 } },
          { content: `HT-${otNum}-${consec}`, styles: { lineColor: 10, lineWidth: 0.02 } },
        ]
      ]
    });

    doc.setFontSize(9);
    doc.setFont(undefined, 'normal');
    doc.text(`Fecha de generación: ${moment(hoja.fechaGeneracion).format('YYYY-MM-DD HH:mm')}`, 1.5, doc.lastAutoTable.finalY + 0.7);
    doc.text(`Autor: ${hoja.autor?.nombre || ''} ${hoja.autor?.apellido || ''}`, 1.5, doc.lastAutoTable.finalY + 1.2);
    if (hoja.estado === 'Anulada') {
      doc.setTextColor(180, 0, 0);
      doc.setFont(undefined, 'bold');
      doc.text(`ANULADA — ${hoja.motivoAnulacion || ''}`, 1.5, doc.lastAutoTable.finalY + 1.7);
      doc.setTextColor(0, 0, 0);
      doc.setFont(undefined, 'normal');
    }

    // Condiciones ambientales.
    const cond = hoja.condicionesAmbientales || {};
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + (hoja.estado === 'Anulada' ? 2.3 : 1.8),
      theme: 'grid',
      headStyles: { fillColor: TEAL, textColor: 255, fontSize: 9 },
      styles: { fontSize: 8 },
      head: [['Condiciones Ambientales', '']],
      body: [
        ['Temperatura', `${cond.temperaturaMin ?? '—'} °C – ${cond.temperaturaMax ?? '—'} °C`],
        ['Humedad Relativa', `${cond.humedadMin ?? '—'} % – ${cond.humedadMax ?? '—'} %`],
      ]
    });

    // Equipos + snapshot resumen.
    const rowsEquipos = (hoja.equipos || []).map((e) => {
      const eq = e.equipoInOt || {};
      const snap = eq.snapshot || {};
      const sesiones = e.snapshotMediciones?.sesiones || [];
      const puntosCount = sesiones.reduce((acc, s) => acc + (s.puntosCalibracion?.length || 0), 0);
      return [
        snap.item || eq.item || '—',
        snap.marca || '—',
        snap.modelo || '—',
        snap.serial || '—',
        sesiones.length,
        puntosCount,
      ];
    });
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 0.5,
      theme: 'grid',
      headStyles: { fillColor: TEAL, textColor: 255, fontSize: 9 },
      styles: { fontSize: 8 },
      head: [['Ítem', 'Marca', 'Modelo', 'Serie', 'Sesiones', 'Puntos']],
      body: rowsEquipos,
    });

    // Patrones usados.
    const rowsPatrones = (hoja.patronesUsados || []).map((p) => [
      p?.item || p?.nombre || String(p).slice(-6),
      p?.marca || '',
      p?.modelo || '',
      p?.serial || p?.serie || '',
    ]);
    if (rowsPatrones.length) {
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 0.5,
        theme: 'grid',
        headStyles: { fillColor: TEAL, textColor: 255, fontSize: 9 },
        styles: { fontSize: 8 },
        head: [['Patrón', 'Marca', 'Modelo', 'Serie']],
        body: rowsPatrones,
      });
    }

    // Firma.
    const yFirma = doc.lastAutoTable.finalY + 3;
    if (firma) {
      try { doc.addImage(firma, 'PNG', 1.5, yFirma - 2, 4, 2); } catch (_) { /* fallback */ }
    }
    doc.line(1.5, yFirma, 8, yFirma);
    doc.setFontSize(9);
    doc.text(`${hoja.autor?.nombre || ''} ${hoja.autor?.apellido || ''}`, 1.5, yFirma + 0.5);
    doc.setFontSize(8);
    doc.text('Metrólogo / Responsable', 1.5, yFirma + 1);

    doc.save(`HojaTrabajo-${otNum}-${consec}.pdf`);
  };

  const autorId = hoja.autor?._id || hoja.autor;
  if (autorId) {
    getDataObtenerUno('sign', { user: autorId })
      .then((signDb) => {
        const firma = signDb?.status === 200 ? signDb?.data?.data?.sign : null;
        render(firma);
      })
      .catch(() => render(null));
  } else {
    render(null);
  }
};

export default PdfHojaTrabajo;
